import React, { useEffect, useState } from "react";
import { Box, IconButton } from "@mui/material";
import ReactPlayer from "react-player";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import ApiService from "./../../services/api-service";

const VideoBanner = () => {
  const [videoUrl, setVideoUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [muted, setMuted] = useState(true); // State to track mute/unmute
  const studioId = "67328fee0f1eb21571707e3e";

  const fetchVideos = async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await ApiService.VIDEO_USER(studioId);
      if (response.result && response.result.length > 0) {
        const latestVideo = response.result
          .sort((a, b) => new Date(b.releaseDate) - new Date(a.releaseDate))[0];
        setVideoUrl(latestVideo.video.url);
      } else {
        setError("No videos available.");
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError("Error fetching videos. Please try again.");
    }
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  const toggleMute = () => {
    setMuted(!muted);
  };

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "0px",
        overflow: "hidden",
        backgroundColor: "#000",
      }}
    >
      {loading ? (
        <Box sx={{ fontSize: "18px", fontWeight: "bold", color: "#fff" }}>
          Loading video...
        </Box>
      ) : error ? (
        <Box sx={{ fontSize: "18px", fontWeight: "bold", color: "#fff" }}>
          {error}
        </Box>
      ) : videoUrl ? (
        <>
          <ReactPlayer
            url={videoUrl}
            width="100%"
            height="100%"
            playing
            muted={muted}
            controls
          />
          <IconButton
            onClick={toggleMute}
            sx={{
              position: "absolute",
              bottom: 16,
              right: 16,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              color: "white",
              "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.7)" },
            }}
          >
            {muted ? <VolumeOffIcon /> : <VolumeUpIcon />}
          </IconButton>
        </>
      ) : (
        <Box sx={{ fontSize: "18px", fontWeight: "bold", color: "#fff" }}>
          No video available.
        </Box>
      )}
    </Box>
  );
};

export default VideoBanner;
